import { BaseModel } from './base-model';

export class Contact extends BaseModel {
  firstName: string;
  middleInitials: string;
  lastName: string;
  isNotifiable: boolean;
  displayName?: string;
  role?: string;
}
